











 


















const node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JiraServerProviderRowTeamMember",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMemberIntegrations",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "JiraServerIntegration",
          "kind": "LinkedField",
          "name": "jiraServer",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TeamMemberIntegrationAuthOAuth1",
              "kind": "LinkedField",
              "name": "auth",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isActive",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationProviderOAuth1",
              "kind": "LinkedField",
              "name": "sharedProviders",
              "plural": true,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamMember",
  "abstractKey": null
};
})();

(node ).hash = "a49d0283f0a138f98e4b25c321c5aeee";

export default node;
